import { useCallback } from 'react'
import { usePlatform, type AsyncOpenTabHandle } from '@shared/platform'
import { usePaymentTrackingParam } from './usePaymentTrackingParam'
import type { InvoiceResponse } from '../api/types'

/**
 * Открывает страницу провайдера в новой вкладке (web → window.open _blank,
 * TG → WebApp.openLink) и записывает `?payment=<tracking_uuid>` в query
 * текущей страницы. Это — триггер для глобальной `PaymentStatusModal`,
 * которая монтируется в shell приложения.
 *
 * Используется одинаково для покупки подписки/курса и для привязки карты.
 *
 * Опциональный `tab` — заранее подготовленный (синхронно по клику) handle от
 * `prepareAsyncOpenTab(platform)`. Нужен в web, чтобы браузер не блокировал
 * popup (`window.open` после await mutate теряет user-gesture). Если `tab`
 * не передан — fallback на `platform.openLink` (как было; для TG это нативно).
 */
export const useStartPayment = () => {
  const platform = usePlatform()
  const { setTrackingUuid } = usePaymentTrackingParam()

  return useCallback(
    (invoice: InvoiceResponse, tab?: AsyncOpenTabHandle) => {
      if (tab) {
        tab.complete(invoice.payment_url)
      } else {
        platform.openLink(invoice.payment_url)
      }
      setTrackingUuid(invoice.tracking_uuid)
    },
    [platform, setTrackingUuid]
  )
}
